export function ChromeLogo({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 12 L0 12 A12 12 0 0 1 18 1.61 Z" fill="#EA4335" />
      <path d="M12 12 L18 1.61 A12 12 0 0 1 18 22.39 Z" fill="#FBBC04" />
      <path d="M12 12 L18 22.39 A12 12 0 0 1 0 12 Z" fill="#34A853" />
      <circle cx="12" cy="12" r="5.4" fill="#FFF" />
      <circle cx="12" cy="12" r="4.2" fill="#4285F4" />
    </svg>
  )
}
